export const MIDDLE_NAME_COUNTRY_CODES = ['UA', 'RU', 'BY', 'AM'];

export const isMiddleName = (
  selectedCountry,
  countriesList = MIDDLE_NAME_COUNTRY_CODES
) => countriesList.includes(selectedCountry);
